import React from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import MenuPereira from '../components/MenuPereira';
import MenuBogota from '../components/MenuBogota';
import MenuAntioquia from '../components/MenuAntioquia';
import FormBookNow from '../components/FormBookNow';
import ProgessTitle from '../components/ProgessTitle';
import Sponsors from '../components/Sponsors';

class BookNow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      booknow: {content: '', title: ''},
      signature: {content: ''},
      error: null,
      slug: null,
      sponsors: []
    }
  }

  componentWillMount() {
    const {slug} = this.props.match.params;
    this.setState({slug: slug});
  }
  
  componentDidMount() {
    this.getData();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({slug: nextProps.match.params.slug});
    this.getData(nextProps.match.params.slug);
  }

  getData(slug = this.state.slug) {
    fetch(`${process.env.REACT_APP_URL}/api/adventures/booknow/${slug}`)
    .then(res => res.json())
    .then(
      (res) => {
        this.setState({booknow: res.booknow});
        this.setState({signature: res.signature});
      },
      (error) => {
        this.setState({error: error});
      }
    )
    return;
  }

  getTour() {
    switch (this.state.slug) {
      case 'coffee-mtb':
        return 'coffee';
      case 'volcano-mtb':
        return 'volcano';
      case 'antioquia-mtb':
        return 'antioquia';
      default:
        return null;
    }
  }

  getMenu() {
    switch (this.state.slug) {
      case 'coffee-mtb':
        return <MenuPereira/>;
      case 'volcano-mtb':
        return <MenuBogota/>;
      case 'antioquia-mtb':
        return <MenuAntioquia/>;
      default:
        return <MenuPereira/>;
    }
  }

  getBanner() {
    switch (this.state.slug) {
      case 'coffee-mtb':
        return <Banner id={60} city="coffee" thumb="logo_adventures.png"/>;
      case 'volcano-mtb':
        return <Banner id={61} city="volcano" thumb="logo_adventures.png"/>;
      case 'antioquia-mtb':
        return <Banner id={64} city="antioquia" thumb="logo_adventures.png"/>;
      default:
        return null;
    }
  }

  render() {
    return (
      <Layout>
        {this.getBanner()}
        {this.getMenu()}
        <div className="row">
          <div className="col-12 text-center">
            <h1 className={`text --${this.getTour()}`}>{this.state.booknow.title_es}</h1>
          </div>
        </div>
        <ProgessTitle
          step1="active"
          tour={this.getTour()}
        />
        <FormBookNow
          package={this.getTour()}
          booknow={this.state.booknow.content_es}
          signature={this.state.signature.content_es}
        />
        <Sponsors
          items={this.state.sponsors}
          city={this.getTour()}
        />
      </Layout>
    );
  }
};

export default BookNow;
